﻿export enum FindByType {
    Undefined = 0,
    Name = 1,
    Number = 2
}